import { InjectionToken } from '@angular/core';

export type VirtualKeyboardConfig =
  | boolean
  | {
      input: boolean;
      textarea: boolean;
    };

export const SOFTLINE_VIRTUAL_KEYBOARD = new InjectionToken<VirtualKeyboardConfig>(
  'SOFTLINE_VIRTUAL_KEYBOARD',
  { factory: () => false }
);
